import React, { useState, useEffect, useCallback } from "react";
import {
  Input,
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Drawer,
} from "@material-tailwind/react";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { BellAlertIcon, QueueListIcon } from "@heroicons/react/24/outline";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";
import { getFeeRate } from "../util/inscribe-util";
import { RiBikeLine } from "react-icons/ri";
import { MdOutlineFlight } from "react-icons/md";
import { BsFillLightningChargeFill } from "react-icons/bs";
import { debounce } from "lodash";
import Connect from "./Connect";
import logo from "../assets/imgs/logo.png";
import { latestDomain, getDomainAddress } from "../util/api";
import { useSelector, useDispatch } from "react-redux";
import { updateKey } from "../store/action";
import { useNavigate, useLocation } from "react-router-dom";
import { getPointData } from "../util/api";
import { useTranslation } from "react-i18next";
import { updateFeeRate, updatePrice } from "../store/action";
import DomainName from "../pages/Inscribe/DomainName";
import { getBtcPrice, getSolanaPrice } from "../util/api";
import LanguageCard from "./LanguageCard";

export default function Header(props) {
  const wallet = useSelector((state) => state.wallet);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { tab, handle, openRightMenu } = props;
  const [key, setKey] = useState("");
  const [feeRates, setFeeRates] = useState({});
  const [point, setPoint] = useState(0);
  const [openUniverseMenu, setOpenUniverseMenu] = useState(false);
  const [openPresaleMenu, setOpenPresaleMenu] = useState(false);
  const [openBrc20Menu, setOpenBrc20Menu] = useState(false);
  const [openIdoMenu, setOpenIdoMenu] = useState(false);
  const [openTapMenu, setOpenTapMenu] = useState(false);
  const [openClaimMenu, setOpenClaimMenu] = useState(false);

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        let response = await getFeeRate();
        let btcPrice= await getBtcPrice();
        let solPrice = await getSolanaPrice();
        let param = {
          bitcoin: btcPrice,
          solana: solPrice
        }
        dispatch(updatePrice(param));
        dispatch(updateFeeRate(response));
        setFeeRates(response);
      } catch (e) {
        console.log(e);
      }
    };
    updateFees();
    intervalId = setInterval(updateFees, 30 * 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const fetchPoints = async () => {
      if (
        wallet.nostrOrdinalsAddress != null &&
        wallet.nostrOrdinalsAddress != ""
      ) {
        let result = await getPointData({
          address: wallet.nostrOrdinalsAddress,
        });
        if (result.total < 0) setPoint(0);
        else setPoint(result.total ?? 0);
      }
    };
    fetchPoints();
  }, [wallet.nostrOrdinalsAddress]);

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      let result = await getDomainAddress(value);
      let domain = "";
      let address = "";

      if (result.total == 0) address = value;
      else {
        domain = result.domain;
        address = result.address;
      }

      let keyData = { address: address, domain: domain };

      dispatch(updateKey(keyData));
      handle(2);
    }, 800),
    []
  );

  const handleKeyChange = (e) => {
    setKey(e.target.value);
    debouncedSearch(e.target.value);
  };

  const logoClick = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-row justify-center h-[65px] fixed top-0 z-50 w-full border-b-[1px] border-b-[#24242a] md:px-2 px-2 text-white bg-background">
      <div className=" flex flex-row justify-between sm:gap-4 gap-1 items-center w-full">
        <div className="flex flex-row md:gap-3 gap-2 items-center">
          <div className="flex flex-row items-center">
            <img
              src={logo}
              className="w-[40px] h-[40px] cursor-pointer"
              onClick={logoClick}
            />
            <div className="md:flex hidden font-bold text-xl ml-2 font-title">
              UNIVERSE
            </div>
          </div>
          <div className="lg:flex hidden flex-row ">
            {tab != 2 ? (
              <Input
                type="text"
                color="white"
                label={t("Input Name Or Address")}
                className="w-full min-w-[230px]"
                value={key}
                onChange={handleKeyChange}
              />
            ) : (
              <></>
            )}
          </div>
          <div
            className={`${
              wallet.nostrPaymentAddress != "" ? "2xl:flex" : "xl:flex"
            } hidden flex-row items-center gap-4 md:ml-2 ml-1 font-title`}
          >
            <div
              className={`${
                tab == 0 ? "text-primary" : "text-white"
              } font-semibold cursor-pointer hover:text-primary text-lg`}
              onClick={() => {
                handle(0);
              }}
            >
              {t("Wallet")}
            </div>
            <Menu>
              <MenuHandler>
                <div
                  className={`${
                    tab == 1 || tab == 19 ? "text-primary" : "text-white"
                  } font-semibold cursor-pointer hover:text-primary text-lg`}
                >
                  {t("Register")}
                </div>
              </MenuHandler>
              <MenuList className="bg-black border-black text-white text-md">
                <MenuItem
                  onClick={() => {
                    handle(19);
                  }}
                >
                  {t("DOMAIN NAMES")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(1);
                  }}
                >
                  {t("UNIVERSE NAMES")}
                </MenuItem>
              </MenuList>
            </Menu>
            <div
              className={`${
                tab == 2 ? "text-primary" : "text-white"
              } font-semibold cursor-pointer hover:text-primary text-lg`}
              onClick={() => {
                handle(2);
              }}
            >
              {t("Explorer")}
            </div>
            {wallet.nostrPaymentAddress != "" ? (
              <div
                className={`${
                  tab == 3 ? "text-primary" : "text-white"
                } font-semibold cursor-pointer hover:text-primary text-lg`}
                onClick={() => {
                  handle(3);
                }}
              >
                {t("My Profile")}
              </div>
            ) : (
              <></>
            )}
            <div
              className={`${
                tab == 4 ? "text-primary" : "text-white"
              } font-semibold cursor-pointer hover:text-primary text-lg`}
              onClick={() => {
                handle(4);
              }}
            >
              {t("Index")}
            </div>
            <Menu>
              <MenuHandler>
                <div
                  className={`${
                    tab == 5 ||
                    tab == 7 ||
                    tab == 9 ||
                    tab == 10 ||
                    tab == 13 ||
                    tab == 12 ||
                    tab == 14 ||
                    tab == 17 ||
                    tab == 28 ||
                    tab == 19
                      ? "text-primary"
                      : "text-white"
                  } font-semibold cursor-pointer hover:text-primary text-lg`}
                >
                  {t("Inscribe")}
                </div>
              </MenuHandler>
              <MenuList className="bg-black border-black text-white text-md">
                <MenuItem
                  onClick={() => {
                    handle(19);
                  }}
                >
                  {t("DOMAIN NAME")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(25);
                  }}
                >
                  ALKANES
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(28);
                  }}
                >
                  OP_RETURN
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(13);
                  }}
                >
                  RUNES
                </MenuItem>
                <Menu
                  placement="right-start"
                  open={openUniverseMenu}
                  handler={setOpenUniverseMenu}
                  allowHover
                  offset={15}
                >
                  <MenuHandler className="flex items-center justify-between">
                    <MenuItem>
                      UNIVERSE
                      <ChevronUpIcon
                        strokeWidth={2.5}
                        className={`h-3.5 w-3.5 transition-transform ${
                          openUniverseMenu ? "rotate-90" : ""
                        }`}
                      />
                    </MenuItem>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white text-md">
                    <MenuItem
                      onClick={() => {
                        handle(5);
                      }}
                    >
                      $TAPZERO
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handle(7);
                      }}
                    >
                      $iSTAMPS
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handle(14);
                      }}
                    >
                      $RUNEZERO
                    </MenuItem>
                  </MenuList>
                </Menu>
                <MenuItem
                  onClick={() => {
                    handle(17);
                  }}
                >
                  DUST-20
                </MenuItem>
                <Menu
                  placement="right-start"
                  open={openTapMenu}
                  handler={setOpenTapMenu}
                  allowHover
                  offset={15}
                >
                  <MenuHandler className="flex items-center justify-between">
                    <MenuItem>
                      TAP
                      <ChevronUpIcon
                        strokeWidth={2.5}
                        className={`h-3.5 w-3.5 transition-transform ${
                          openTapMenu ? "rotate-90" : ""
                        }`}
                      />
                    </MenuItem>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white text-md">
                    <MenuItem
                      onClick={() => {
                        handle(9);
                      }}
                    >
                      {t("DEPLOY")} & {t("MINT")} TAP
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handle(10);
                      }}
                    >
                      {t("DEPLOY")} & {t("MINT")} DMT
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handle(12);
                      }}
                    >
                      {t("DEPLOY")} & {t("MINT")} BLOCKDROP
                    </MenuItem>
                  </MenuList>
                </Menu>
              </MenuList>
            </Menu>
            <div
              className={`${
                tab == 6 || tab == 30 || tab == 31 ? "text-primary" : "text-white"
              } font-semibold cursor-pointer hover:text-primary text-lg`}
              onClick={() => {
                handle(6);
              }}
            >
              {t("Trade")}
            </div>
            <Menu>
              <MenuHandler>
                <div
                  className={`${
                    tab == 11 || tab == 8 || tab == 15 || tab == 21 || tab == 20 || tab == 23 ? "text-primary" : "text-white"
                  } font-semibold cursor-pointer hover:text-primary text-lg`}
                >
                  {t("Tools")}
                </div>
              </MenuHandler>
              <MenuList className="bg-black border-black text-white text-md">
                <MenuItem
                  onClick={() => {
                    handle(8);
                  }}
                >
                  {t("CHAT")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(11);
                  }}
                >
                  TAP {t("AIRDROP")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(15);
                  }}
                >
                  TAP2BRC20
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(16);
                  }}
                >
                  {t("LAUNCHPAD")}
                </MenuItem>
                <Menu
                  placement="right-start"
                  open={openPresaleMenu}
                  handler={setOpenPresaleMenu}
                  allowHover
                  offset={15}
                >
                  <MenuHandler className="flex items-center justify-between">
                    <MenuItem>
                      PRESALE
                      <ChevronUpIcon
                        strokeWidth={2.5}
                        className={`h-3.5 w-3.5 transition-transform ${
                          openPresaleMenu ? "rotate-90" : ""
                        }`}
                      />
                    </MenuItem>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white text-md">
                    <Menu
                      placement="right-start"
                      open={openBrc20Menu}
                      handler={setOpenBrc20Menu}
                      allowHover
                      offset={15}
                    >
                      <MenuHandler className="flex items-center justify-between">
                        <MenuItem>
                          BRC20
                          <ChevronUpIcon
                            strokeWidth={2.5}
                            className={`h-3.5 w-3.5 transition-transform ${
                              openBrc20Menu ? "rotate-90" : ""
                            }`}
                          />
                        </MenuItem>
                      </MenuHandler>
                      <MenuList className="bg-black border-black text-white text-md">
                        {/* <MenuItem
                          onClick={() => {
                            handle(21);
                          }}
                        >
                          🜟
                        </MenuItem> */}
                        <MenuItem
                          onClick={() => {
                            handle(22);
                          }}
                        >
                          🝏 
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </MenuList>
                </Menu>
                <Menu
                  placement="right-start"
                  open={openIdoMenu}
                  handler={setOpenIdoMenu}
                  allowHover
                  offset={15}
                >
                  <MenuHandler className="flex items-center justify-between">
                    <MenuItem>
                      IDO
                      <ChevronUpIcon
                        strokeWidth={2.5}
                        className={`h-3.5 w-3.5 transition-transform ${
                          openIdoMenu ? "rotate-90" : ""
                        }`}
                      />
                    </MenuItem>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white text-md">
                    <MenuItem
                      onClick={() => {
                        handle(20);
                      }}
                    >
                      BRC20
                    </MenuItem>
                  </MenuList>
                </Menu>
                <Menu
                  placement="right-start"
                  open={openClaimMenu}
                  handler={setOpenClaimMenu}
                  allowHover
                  offset={15}
                >
                  <MenuHandler className="flex items-center justify-between">
                    <MenuItem>
                      CLAIM
                      <ChevronUpIcon
                        strokeWidth={2.5}
                        className={`h-3.5 w-3.5 transition-transform ${
                          openPresaleMenu ? "rotate-90" : ""
                        }`}
                      />
                    </MenuItem>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white text-md">
                    <Menu
                      placement="right-start"
                      open={openBrc20Menu}
                      handler={setOpenBrc20Menu}
                      allowHover
                      offset={15}
                    >
                      <MenuHandler className="flex items-center justify-between">
                        <MenuItem>
                          BRC20
                          <ChevronUpIcon
                            strokeWidth={2.5}
                            className={`h-3.5 w-3.5 transition-transform ${
                              openBrc20Menu ? "rotate-90" : ""
                            }`}
                          />
                        </MenuItem>
                      </MenuHandler>
                      <MenuList className="bg-black border-black text-white text-md">
                        <MenuItem
                          onClick={() => {
                            handle(23);
                          }}
                        >
                          🜷
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handle(24);
                          }}
                        >
                          TAP
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </MenuList>
                </Menu>
                {/* <MenuItem onClick={() => {handle(18)}}>UNLOCK UTXOS</MenuItem> */}
              </MenuList>
            </Menu>
            <Menu>
              <MenuHandler>
                <div
                  className={`${
                    tab == 25 || tab == 26 || tab == 27 ? "text-primary" : "text-white"
                  } font-semibold cursor-pointer hover:text-primary text-lg`}
                >
                  {t("Alkanes")}
                </div>
              </MenuHandler>
              <MenuList className="bg-black border-black text-white text-md">
                <MenuItem
                  onClick={() => {
                    handle(25);
                  }}
                >
                  {t("MINT")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(26);
                  }}
                >
                  {t("EXPLORER")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    window.open('https://launchpad.bitcoinuniverse.io', '_blank')
                  }}
                >
                  {t("LAUNCHPAD")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(27);
                  }}
                >
                  {t("LEADERBOARD")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(29);
                  }}
                >
                  ClockInSystem ({t("Manual")})
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handle(32);
                  }}
                >
                  ClockInSystem ({t("Automated")})
                </MenuItem>
              </MenuList>
            </Menu>
          </div>
        </div>
        <div className="flex flex-row sm:gap-1 gap-0 h-[44px]">
          <div className="pt-2 mr-1">
            <LanguageCard />
          </div>
          <a
            href="https://x.com/bitcoinunified"
            className="sm:m-[0px] sm:flex hidden"
            target="_blank"
          >
            <img
              src="https://mscribe-webapp.s3.amazonaws.com/twitter.png"
              alt="Twitter"
              className="cursor-pointer sm:w-[45px] w-[40px] mt-1 p-2 "
            />
          </a>
          <a
            href="https://discord.com/invite/Auq977wfM8"
            className="sm:m-[0px] sm:flex hidden mr-[-8px]"
            target="_blank"
          >
            <img
              src="https://mscribe-webapp.s3.amazonaws.com/discord.png"
              alt="Discord"
              className="cursor-pointer sm:w-[45px] w-[40px] mt-1 p-2"
            />
          </a>
          <a href="https://t.me/bitcoinunified" target="_blank">
            <div className="sm:flex hidden flex-row p-2">
              <span className="sm:text-[32px] text-[28px] text-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <path d="M231.3,31.7A16.1,16.1,0,0,0,215,29L30.4,101.5a15.8,15.8,0,0,0-10.1,16.3,16,16,0,0,0,12.8,14.3L80,141.4V200a16,16,0,0,0,9.9,14.8A16.6,16.6,0,0,0,96,216a15.8,15.8,0,0,0,11.3-4.7l26-25.9L172.6,220a16,16,0,0,0,10.5,4,14.2,14.2,0,0,0,5-.8,15.9,15.9,0,0,0,10.7-11.6L236.4,47.4A16,16,0,0,0,231.3,31.7ZM183.2,208l-82.4-72.5L219.5,49.8Z"></path>
                </svg>
              </span>
            </div>
          </a>
          <div className="flex flex-row gap-1">
            {wallet.nostrOrdinalsAddress != "" &&
            wallet.nostrOrdinalsAddress != null ? (
              <div className="flex flex-row items-center gap-2 rounded-full cursor-pointer bg-primary hover:bg-primary-hover sm:px-4 px-5 py-1 h-full">
                <RocketLaunchIcon
                  strokeWidth={2}
                  className="h-5 w-5 sm:flex hidden"
                />
                <span>{point}</span>
              </div>
            ) : (
              <></>
            )}

            <div className="sm:block hidden h-full">
              <Popover placement="bottom-end">
                <PopoverHandler>
                  <div className="flex flex-row items-center gap-2 rounded-full cursor-pointer bg-primary hover:bg-primary-hover px-4 py-1 h-full">
                    <BellAlertIcon strokeWidth={2} className="h-5 w-5" />
                    <span>{feeRates.Normal}</span>
                  </div>
                </PopoverHandler>
                <PopoverContent className="bg-black border-black">
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-row gap-2 itmes-center">
                      <RiBikeLine className="text-white text-lg" />
                      <span className="text-white font-semibold">
                        {t("Low")}: {feeRates.Slow}&nbsp;sats/vB
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 itmes-center">
                      <MdOutlineFlight className="text-white text-lg" />
                      <span className="text-white font-semibold">
                        {t("Medium")}: {feeRates.Normal}&nbsp;sats/vB
                      </span>
                    </div>
                    <div className="flex flex-row gap-2 itmes-center">
                      <BsFillLightningChargeFill className="text-white text-lg" />
                      <span className="text-white font-semibold">
                        {t("High")}: {feeRates.Fast}&nbsp;sats/vB
                      </span>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
            <Connect />
            <div
              className={`${
                wallet.nostrPaymentAddress != "" ? "2xl:hidden" : "xl:hidden"
              } flex`}
            >
              <div
                className="flex flex-row items-center gap-2 rounded-md cursor-pointer bg-primary hover:bg-primary-hover px-[10px] py-2"
                onClick={openRightMenu}
              >
                <QueueListIcon strokeWidth={2} className="h-5 w-5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
